window.addEventListener('load', function() {
    document.getElementById('loading-bg').classList.add('remove-loading');
    setTimeout(function() {
        document.getElementById('loading-bg').remove();
        document.body.style.overflow = 'auto';
    }, 200);

    document.querySelector(".header-menu-button__svg").addEventListener("click", () => {
        document.body.classList.toggle("menu-open");
    });
});
